// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__HeIzm","hand":"Home_hand__3jRFr","wave":"Home_wave__Rx6cd"};